<template>
  <div class="mt-5 mx-5">
    <paywall
      :feature-type="FEATURE_TYPE.BOOLEAN"
      learn-more-link="https://thenorth.io/help/initiatives-tab/"
    >
      <div slot="heading">See all initiatives on a single page</div>
      <div slot="content">
        You can choose to see them as list or a board view. Both views allow powerful grouping and
        filtering functionality for you to stay on top of your projects.
      </div>
    </paywall>
  </div>
</template>

<script>
import { trackAnalyticsEvent } from '@/analytics'
import Paywall from '@/components/paywalls/Paywall.vue'
import { EVENT_ACTION, EVENT_CATEGORY } from '@/constants/analytics'
import { FEATURE_TYPE } from '@/constants/featureFlags'

/**
 * This is the paywall for initiatives tab on team page
 */
export default {
  name: 'InitiativesTabPaywall',
  props: [],
  components: {
    Paywall
  },
  data() {
    return {
      FEATURE_TYPE
    }
  },
  computed: {},
  methods: {},
  mounted() {
    trackAnalyticsEvent(EVENT_CATEGORY.UPGRADES, EVENT_ACTION.PAYWALL_CLICKED, {
      paywall: 'Initiative Tab'
    })
  }
}
</script>
